import { render, staticRenderFns } from "./NewlyaddedOrderListModel.vue?vue&type=template&id=44b89aac&scoped=true&"
import script from "./NewlyaddedOrderListModel.vue?vue&type=script&lang=js&"
export * from "./NewlyaddedOrderListModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b89aac",
  null
  
)

export default component.exports